import { useEffect } from "react";
import { getSocket } from "@shared/config/socketClient";

/**
 * Hook para escuchar un evento de Socket.io de forma declarativa.
 * Se suscribe automáticamente al montar y se desuscribe al desmontar.
 *
 * @param {string} event - Nombre del evento a escuchar
 * @param {Function} handler - Callback que recibe los datos del evento
 * @param {boolean} [enabled=true] - Si false, no se suscribe
 */
export default function useSocketEvent(event, handler, enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const socket = getSocket();
    if (!socket) return;

    socket.on(event, handler);

    return () => {
      socket.off(event, handler);
    };
  }, [event, handler, enabled]);
}
